import {
  icons,
  Spinner,
  SpinnerWrapper,
} from "@appquality/appquality-design-system";
import i18n from "i18next";
import { useTranslation } from "react-i18next";
import { shallowEqual, useSelector } from "react-redux";
import { useLocalizeRoute } from "src/hooks/useLocalizedRoute";
import getCurrencySymbol from "src/utils/getCurrencySymbol";
import styled from "styled-components";
import { Level } from "../Ranking/Level";
import usePerformance from "./effects/usePerformance";
import { GoToBlock, Statistic } from "./performanceRow";

const StyledIcon = styled.div`
  .dark-disabled-font {
    color: ${(props) => props.theme.colors.disabledDark};
  }
`;

const PerformanceData = () => {
  const { t } = useTranslation();
  const {
    BookmarkCheckFill,
    BugFill,
    PiggyBankFill,
    StarFill,
    CashCoin,
    ArrowRight,
    Star,
  } = icons;
  const {
    expPoints,
    cpCompleted,
    bugsApproved,
    allBooty,
    pendingBooty,
    loading,
  } = usePerformance();

  const { summary } = useSelector(
    (state: GeneralState) => state.ranking,
    shallowEqual
  );
  const BootyComponent = ({
    booty,
    title,
    ...props
  }: {
    booty: typeof allBooty;
    title: string;
  }) => {
    if (!booty) return <span>-</span>;
    return (
      <div {...props}>
        {booty.net ? (
          <>
            <strong className="booty" data-qa="net-booty">
              <span className="left">{title}</span>
              <span className="right">
                {`${getCurrencySymbol(booty.net.currency)}${booty.net.value}`}
              </span>
            </strong>
            <span data-qa="gross-booty">
              ({t("Gross")}{" "}
              {`${getCurrencySymbol(booty.gross.currency)}${booty.gross.value}`}
              )
            </span>
          </>
        ) : (
          <div className="booty" data-qa="gross-booty">
            <strong className="left">{t("Gross")}</strong>
            <strong className="right">
              {`${getCurrencySymbol(booty.gross.currency)}${booty.gross.value}`}
            </strong>
          </div>
        )}
      </div>
    );
  };
  const performanceData = [
    {
      icon: <StarFill size={"21"} className={"aq-text-warningVariant"} />,
      text: t("__CARD_RECAP_DASHBOARD_LABEL_PUNTI-TOTALI_MAX: 25", {
        defaultValue: "Total exp points",
      }),
      val: expPoints,
    },
    {
      icon: <Star size={"21"} className={"aq-text-primaryVariant"} />,
      text: t("__CARD_RECAP_DASHBOARD_LABEL_PUNTI-MENSILI_MAX: 25", {
        defaultValue: "Monthly exp points",
      }),
      val: summary?.points || 0,
    },
    ...(summary?.level
      ? [
          {
            icon: <Level level={summary?.level} hideName />,
            text:
              summary.level.id === 0
                ? summary.level.name
                : t(
                    "level {{ level }}:::__CARD_RECAP_DASHBOARD_LABEL_LIVELLO_MAX: 20",
                    {
                      defaultValue: "Level {{ level }}",
                      level: summary?.level.name,
                    }
                  ),
            val: summary.level.id === 0 ? "" : `${summary.rank}°`,
          },
        ]
      : []),
    {
      icon: <ArrowRight size={"21"} />,
      text: t("__CARD_RECAP_DASHBOARD_CTA_MAX: 30", {
        defaultValue: "View ranking page",
      }),
      link: `${useLocalizeRoute("leaderboard")}`,
    },
    {
      icon: (
        <BookmarkCheckFill size={"21"} className={"aq-text-secondaryVariant"} />
      ),
      text: t("Completed campaigns"),
      val: cpCompleted,
    },
    {
      icon: <BugFill size={"21"} className={"aq-text-dangerVariant"} />,
      text: t("Approved bugs"),
      val: bugsApproved,
    },
    {
      icon: <ArrowRight size={"21"} />,
      text: t("View bugs page"),
      link: `${useLocalizeRoute("my-bugs")}`,
    },
    {
      icon: <CashCoin size={"21"} className={"aq-text-success"} />,
      text: t("Received booty"),
      booty: (
        <BootyComponent
          title={t("Net received")}
          booty={allBooty}
          data-qa="received-booty"
        />
      ),
    },
    {
      icon: (
        <StyledIcon>
          <PiggyBankFill size={"21"} className={"aq-text-successVariant"} />
        </StyledIcon>
      ),
      text: t("Available booty"),
      booty: (
        <BootyComponent
          title={t("Net receivable")}
          booty={pendingBooty}
          data-qa="pending-booty"
        />
      ),
    },
    {
      icon: <ArrowRight size={"21"} />,
      text: t("View payments page"),
      link: `${useLocalizeRoute("payments")}`,
    },
  ];

  if (loading) {
    return (
      <SpinnerWrapper>
        <Spinner />
      </SpinnerWrapper>
    );
  }
  return (
    <div>
      {performanceData.map((item, index) => {
        return item.link ? (
          <GoToBlock item={item} key={index} />
        ) : (
          <Statistic item={item} key={index} hasSecondRow={!!item.booty} />
        );
      })}
    </div>
  );
};

export default PerformanceData;
